import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Locker = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="locker"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.0833 10.5H18.8333V8.83332C18.8333 5.6168 16.2166 3 13 3C9.78344 3 7.16668 5.6168 7.16668 8.83332V10.5H5.91668C5.68637 10.5 5.5 10.6864 5.5 10.9167V21.3334C5.5 22.2525 6.24746 23 7.16668 23H18.8334C19.7525 23 20.5 22.2525 20.5 21.3333V10.9167C20.5 10.6864 20.3136 10.5 20.0833 10.5ZM14.2476 19.204C14.2606 19.3216 14.2228 19.4396 14.1438 19.5279C14.0649 19.6162 13.9518 19.6667 13.8334 19.6667H12.1667C12.0483 19.6667 11.9352 19.6162 11.8562 19.5279C11.7773 19.4396 11.7394 19.3216 11.7525 19.204L12.0153 16.8404C11.5885 16.5299 11.3334 16.0387 11.3334 15.5C11.3334 14.5808 12.0808 13.8333 13 13.8333C13.9193 13.8333 14.6667 14.5808 14.6667 15.5C14.6667 16.0387 14.4116 16.5299 13.9848 16.8404L14.2476 19.204ZM16.3333 10.5H9.66668V8.83332C9.66668 6.99535 11.162 5.5 13 5.5C14.838 5.5 16.3333 6.99535 16.3333 8.83332V10.5Z" />
    </svg>
  );
};
/* eslint-enable max-len */

Locker.defaultProps = {
  className: null,
};

Locker.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Locker;
